import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import BasicInput from "../../BasicInput";
import { stationeryNumbers } from "../../../data/stationery";
import { useTranslation } from "react-i18next";
import {
  useMainContext,
  useStationeryContext,
} from "../../../context/MainContext";
import { handleInputValue } from "../../../utils/handleInputValue";
import {
  boxExcludeInput,
  imageExcludeInput,
  inputExcludeInput,
  lineExcludeInput,
} from "../variables/stationeryObjectCodes";
import { updateStationaryItem } from "../../../screens/MainFrame/functions/stationery/updateStationaryItem";
import { callStationeryImages } from "../../../screens/MainFrame/functions/stationery/callStationeryImages";

export default function EditorBox({ parts }: stdObject) {
  const { t } = useTranslation();
  const {
    closeMsg,
    staValues,
    setMsg2,
    setModalData2,
    setStaValues,
    logoutAction,
  } = useMainContext();
  const { tabIndex, selected, editValues } = useStationeryContext();

  const validateInput = (e: stdObject) => {
    switch (parts[selected.index].TIPPAR) {
      case 6:
        return !boxExcludeInput.includes(e.code);
      case 7:
        return !lineExcludeInput.includes(e.code);
      case 8:
        return !imageExcludeInput.includes(e.code);
      case 9:
      case 10:
      case 11:
      case 12:
      case 15:
        return !inputExcludeInput.includes(e.code);
    }
    return !["TIPPAR", "TXTPAR", "IMGPAR", "PROPAR"].includes(e.code);
  };

  const writePayLabel = (e: stdObject) =>
    e.code === "TXTPAR" && parts[selected.index].TIPPAR === 8
      ? t(`p.title`)
      : parts[selected.index].TIPPAR === 7 &&
          ["BOLPAR", "ITAPAR"].includes(e.code)
        ? e.code === "BOLPAR"
          ? t(`p.vertical`)
          : t(`p.inclined`)
        : t(`s.${e.code}`);

  return (
    <div
      style={{
        height: tabIndex && selected.index > -1 ? "70%" : 0,
        overflow: "auto",
        borderTop: tabIndex && selected.index > -1 ? "3px solid black" : 0,
      }}
    >
      {selected.index > -1 && (
        <table width={"100%"}>
          <tbody>
            {editValues
              .filter((e: stdObject) => e)
              .map(
                (e: stdObject, index: number) =>
                  validateInput(e) && (
                    <BasicInput
                      key={index}
                      label={e.label ?? writePayLabel(e)}
                      isTable={true}
                      type={e.type}
                      value={
                        parts[selected.index].TIPPAR === 8 &&
                        e.code === "IMGPAR" &&
                        parts[selected.index][e.code] === ""
                          ? t("p.selectAnImage")
                          : parts[selected.index][e.code]
                      }
                      options={e.options}
                      suffix={
                        stationeryNumbers.includes(e.code)
                          ? t("p.inches")
                          : e.suffix
                      }
                      style={e.style}
                      innerStyle={
                        stationeryNumbers.includes(e.code)
                          ? { width: 60 }
                          : parts[selected.index].TIPPAR === 8 &&
                              e.code === "IMGPAR"
                            ? { cursor: "pointer" }
                            : e.innerStyle
                      }
                      onChange={(v: {
                        target: { value: SetStateAction<string> };
                      }) => {
                        if (
                          parts[selected.index].TIPPAR === 8 &&
                          e.code === "IMGPAR"
                        ) {
                          callStationeryImages(parts[selected.index].NUMPAR, {
                            t,
                            setModalData2,
                            setMsg2,
                            closeMsg,
                            staValues,
                            setStaValues,
                            logoutAction,
                          });
                        } else {
                          const value =
                            e.code === "TIPPAR"
                              ? Number(v.target.value)
                              : v.target.value;
                          updateStationaryItem(
                            parts[selected.index].NUMPAR,
                            {
                              [e.code]: handleInputValue(e.type, value),
                            },
                            { staValues, setStaValues },
                          );
                        }
                        return true;
                      }}
                    />
                  ),
              )}
          </tbody>
        </table>
      )}
    </div>
  );
}
